import React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@app/shared/utils/common';

const headingVariants = cva('font-semibold text-2xl', {
  variants: {
    level: {
      1: 'text-3xl',
      2: 'text-2xl',
      3: 'text-xl',
      4: 'text-lg',
      5: 'text-base',
      6: 'text-base',
    },
  },
  defaultVariants: {
    level: 1,
  },
});

export interface HeadingProps
  extends React.HTMLAttributes<HTMLHeadingElement>, VariantProps<typeof headingVariants> {
  asChild?: boolean;
}

const Heading = React.forwardRef<HTMLParagraphElement, HeadingProps>(
  ({ className, level = 1, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'h' + String(level);
    return <Comp className={cn(headingVariants({ level, className }))} ref={ref} {...props} />;
  }
);
Heading.displayName = 'Heading';

export { Heading };
